<template lang="pug">
  div.event-vein-line
    div.title
      div.left-side
      div.right-side
        el-checkbox(v-model="type" label="标注时间轴" v-show="activeView.alias === 'hour'")
        button.option(v-for="button in switcher",
          :class="{active: button.active}",
          @click.prevent="switchType(button)") {{button.name}}
    div.event-evin-chart
      keep-alive
        component(:is="activeView.component",
                  :line-data="platforms",
                  :venation-day="venation",
                  :day-line-loaded="dayLineLoaded",
                  :hour-line-loaded="hourLineLoaded",
                  :venation-hour="venation",
                  :nodes="nodes",
                  :ref="activeView.ref")

</template>
<script>
import client from '../server/server'
import DayLine from './DayLine'
import HourLine from './HourLine'
import _ from 'lodash'
import moment from 'moment'
import { venationsConfig } from '../config/config'
export default {
  name: 'EventVeinLine',
  data () {
    return {
      switcher: [
        {
          name: '小时',
          alias: 'hour',
          active: true,
          component: HourLine,
          ref: 'HourLine'
        },
        {
          name: '天',
          alias: 'day',
          active: false,
          component: DayLine,
          ref: 'DayLine'
        }
      ],
      platforms: [
        {
          name: '全部',
          alias: 'all',
          color: '#3989cb',
          active: true
        },
        {
          name: '正面',
          alias: 'pos',
          color: '#5dca6f',
          active: false
        },
        {
          name: '中性',
          alias: 'neu',
          color: '#f8c453',
          active: false
        },
        {
          name: '负面',
          alias: 'neg',
          color: '#ff7676',
          active: false
        }
      ],
      dayLineLoaded: false,
      venation: [],
      nodes: [],
      hourLineLoaded: false,
      type: false
    }
  },
  created () {
    this.getHourLine()
  },
  computed: {
    activeView () {
      return this.switcher.find(d => d.active)
    }
  },
  watch: {
    type (val) {
      this.$refs.HourLine.showVenations(val ? 'block' : 'none')
    }
  },
  methods: {
    switchType (item) {
      this.switcher.forEach(e => {
        e.active = item.name === e.name
      })
      if (item.alias === 'day') {
        // do day
        this.getDayLine()
      } else {
        // do hour
        this.getHourLine()
      }
    },
    render () {
    },
    renderLineHour () {},
    getDayLine () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventTendency(params)
        .then(res => {
          let data = {
            all: {
              avg: res.data.avgDayCount,
              high: _.maxBy(res.data.lineDay, d => d.articleCount).articleCount,
              lineDay: res.data.lineDay.map(d => {
                return {
                  num: d.articleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            },
            pos: {
              avg: res.data.avgDayCount,
              high: _.maxBy(res.data.lineDay, d => d.articleCount).articleCount,
              lineDay: res.data.lineDay.map(d => {
                return {
                  num: d.posArticleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            },
            neu: {
              avg: res.data.avgDayCount,
              high: _.maxBy(res.data.lineDay, d => d.articleCount).articleCount,
              lineDay: res.data.lineDay.map(d => {
                return {
                  num: d.neuArticleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            },
            neg: {
              avg: res.data.avgHourCount,
              high: _.maxBy(res.data.lineDay, d => d.articleCount).articleCount,
              lineDay: res.data.lineDay.map(d => {
                return {
                  num: d.negArticleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            }
          }
          this.platforms = this.platforms.map(d => {
            return Object.assign({}, d, {
              day: data[d.alias]
            })
          })
          this.venation = {
            lurk: res.data.times[0],
            hot: res.data.times[1],
            recession: res.data.times[2]
          }
          this.dayLineLoaded = true
        })
    },
    getHourLine () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventTendency(params)
        .then(res => {
          let data = {
            all: {
              avg: res.data.avgHourCount,
              high: _.maxBy(res.data.lineHour, d => d.articleCount).articleCount,
              lineHour: res.data.lineHour.map(d => {
                return {
                  num: d.articleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            },
            pos: {
              avg: res.data.avgHourCount,
              high: _.maxBy(res.data.lineHour, d => d.articleCount).articleCount,
              lineHour: res.data.lineHour.map(d => {
                return {
                  num: d.posArticleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            },
            neu: {
              avg: res.data.avgHourCount,
              high: _.maxBy(res.data.lineHour, d => d.articleCount).articleCount,
              lineHour: res.data.lineHour.map(d => {
                return {
                  num: d.neuArticleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            },
            neg: {
              avg: res.data.avgHourCount,
              high: _.maxBy(res.data.lineHour, d => d.articleCount).articleCount,
              lineHour: res.data.lineHour.map(d => {
                return {
                  num: d.negArticleCount,
                  publishTime: d.time,
                  publishTimeHour: moment(d.time).format('YYYY-MM-DD HH')
                }
              }),
              nodes: []
            }
          }
          this.platforms = this.platforms.map(d => {
            return Object.assign({}, d, {
              hour: data[d.alias]
            })
          })
          this.venation = {
            lurk: res.data.times[0],
            hot: res.data.times[1],
            recession: res.data.times[2]
          }
          this.nodes = res.data.venations.map(d => {
            return Object.assign({}, d, {
              organization: venationsConfig[d.organization]
            })
          })
          this.hourLineLoaded = true
        })
    }
  },
  components: {
    DayLine,
    HourLine
  }
}
</script>
<style lang="scss" scoped>
.title {
    padding: 0 15px;
    height: 50px;
    background-color: #ffffff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    span {
      margin-right: 25px;
    }
}
.event-vein-line {
  margin-top: 15px;
  height: 550px;
}
.event-evin-chart {
  height: 500px;
  position: relative;
}
  .right-side{
    display: flex;
    align-items: center;
    & /deep/ .el-checkbox__label{
      font-size: 12px;
      margin-right: 20px;
    }
  }

</style>

<style lang="scss">
.event-vein-line {
  .option {
    width: 40px;
    height: 26px;
    background: #ffffff;
    border: solid 1px #e8ebf1;
    color: #333333;
    font-size: 12px;
    &:first-child{
      border-radius: 4px 0 0 4px;
    }
    &:last-child{
      border-radius: 0 4px 4px 0;
    }
    &.active{
      background: #3989cb;
      border: solid 1px #3989cb;
      color:#fff;
    }
  }
  .legend  {
    float: left;
    margin-left: 10px;
    &:hover{
      cursor: pointer;
    }
  }
  .dot {
    margin-right: 3px;
  }

  .area {
    fill: steelblue;
    clip-path: url(#clip);
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/index/EventTendency/EventVeinLine.vue